import React, {useState} from 'react';
import { db, auth } from '../firebaseConfig';
import {useEffect} from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import TableUserData from '../Components/TableUserData';
import Graph from '../Components/Graph';
import UserInfo from '../Components/UserInfo';


const UserPage = () => {

   const[data, setData] =useState([]);
   const[user, loading] = useAuthState(auth);             //to get current logged in user real time
   const [dataLoading, setDataLoading] = useState(true);  //state to check if data is loading from firebase or not
   const navigate = useNavigate();
   const [graphData, setGraphData] = useState([]);       //state to hold graph data WPM vs Time
   
   const fetchUserData = () => {   //USED TO FETCH DATA
      const resultRef = db.collection('Results');     //REFERENCE given to results collection
      const { uid } = auth.currentUser;   //getting current logged in user's uid
      let tempData = [];
      let tempGraphData = [];
      resultRef.where("userId", "==", uid)
      .orderBy("timeStamp","desc")   //based on timestamp order the data in descending order
      .get().then((snapshot) => {            //to fetch all documents from results collection
        snapshot.docs.forEach((doc) => {
          tempData.push({...(doc.data())});
          tempGraphData.push([doc.data().timeStamp.toDate().toLocaleString().split(',')[0], doc.data().wpm]);  //pushing array of [time,wpm] to graph data
        });
        setData(tempData);
        setGraphData(tempGraphData.reverse());  //as we want graph data in ascending order of time so reversing it
        setDataLoading(false);
      });
   };
   
   useEffect(() => {
     if(!loading){
        fetchUserData();     //when compoenent loads then firebase also loads data from firestore
     }
     if(!loading && !user){
      navigate('/');      //if user is not logged in then navigate to home page
     }
   },[loading])

     if(loading || dataLoading){   //while firebase is loading user data show loading spinner
      return <div className="center-of-screen">
        <CircularProgress  size ={300}/>
      </div>;
     }

  return(
    <div className="canvas">
      <UserInfo totalTestsTaken={data.length}/>       {/*component to show user info like name,email*/}
      <div className="graph-user-page">
        <Graph graphData={graphData} type ='date'/>
      </div>
      
      <TableUserData data={data}/>
    </div>
  )
}
export default UserPage;